// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"2a952952","259":"149181fb","493":"ae2f1d28","503":"e8dd30ee","631":"280f3506","787":"cda612ba"}[chunkId] + ".chunk.js";
};